/**
 * Mock data for the customer-facing /service/:token page.
 *
 * Everything here is intentionally fake — once the backend exposes
 * customer-side endpoints for QR Service, replace these with real
 * service-class calls.
 */

export const MOCK_WIFI = {
  ssid: 'SilverSpoon_Guest',
  password: 'welcome2026',
};

export const MOCK_LOYALTY = {
  member: null,            // null = not linked yet
  points_per_baht: 1,
  redeem_rate: '100 pts = ฿20',
  available_rewards: [
    { id: 'r1', name: 'Free Thai Iced Tea',  cost: 200 },
    { id: 'r2', name: '฿50 off this bill',   cost: 300 },
    { id: 'r3', name: 'Free Mango Sticky Rice', cost: 500 },
  ],
};

/**
 * Pre-order = items the customer reserves ahead of arrival or for
 * later in the session (e.g. dessert after main course).
 */
export const MOCK_PREORDER_SLOTS = [
  { id: 's1', label: 'Serve now' },
  { id: 's2', label: 'After mains' },
  { id: 's3', label: 'In 15 min' },
  { id: 's4', label: 'In 30 min' },
];
